import { render, staticRenderFns } from "./EventsTemplate.vue?vue&type=template&id=3f5d8dad"
import script from "./EventsTemplate.vue?vue&type=script&lang=js"
export * from "./EventsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports